
  export default {
    props: { showIcon: { type: Boolean, default: true } }
  };
